/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Shop_Guide_Video_Poster_Not_ImageInputs */

const vi_error_shop_guide_video_poster_not_image = /** @type {(inputs: Error_Shop_Guide_Video_Poster_Not_ImageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ảnh bìa phải là ảnh JPG, PNG hoặc WEBP — hãy chọn lại.`)
};

/**

* @param {Error_Shop_Guide_Video_Poster_Not_ImageInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const error_shop_guide_video_poster_not_image = /** @type {((inputs?: Error_Shop_Guide_Video_Poster_Not_ImageInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Shop_Guide_Video_Poster_Not_ImageInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_error_shop_guide_video_poster_not_image(inputs)
});